export default __webpack_public_path__ + "static/media/cookies.91c4db8f.svg";